import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectApi(data) {
  return request({
    url: `/admin/informationReservationUser/select`,
    method: "POST",
    data,
    // isEncrypt:false,
    // isDecrypt:false
  });
}
